import { apiJson } from '@/api/client'
import type { ScenarioCatalogEntry, ScenarioCatalogStatus } from './types'

/**
 * The wire shape for `/api/v1/scenarios` is defined in
 * internal/api/scenarios_handler.go (scenarioView). Two flavours land
 * here:
 *   1. The Go projection — { code, name, is_enabled, approval_state, … }
 *   2. The React-aligned projection (also emitted by the Go handler
 *      and by the MSW fixtures) — { code, name, status, … }
 *
 * `deriveStatus` collapses both to the three-value ScenarioCatalogStatus
 * enum the picker binds to.
 */
interface WireScenario {
  code: string
  name: string
  status?: string
  is_enabled?: boolean
  approval_state?: string
}

function deriveStatus(w: WireScenario): ScenarioCatalogStatus {
  if (w.status === 'enabled' || w.status === 'shadow' || w.status === 'disabled') {
    return w.status
  }
  if (w.approval_state === 'shadow') return 'shadow'
  return w.is_enabled ? 'enabled' : 'disabled'
}

export async function listScenarioCatalog(): Promise<ScenarioCatalogEntry[]> {
  const wire = await apiJson<{ scenarios: WireScenario[] }>(`/scenarios`)
  return (wire.scenarios ?? []).map((s) => ({
    code: s.code,
    name: s.name,
    status: deriveStatus(s),
  }))
}
